module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_fondo_15.b6a1fc0d.png";